import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Store } from '../state-man/models/store.model';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';
import { User } from '../state-man/models/user.model';
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }
 
  public async getAll (user: User, last_update: string) : Promise<Store[] | null> {      
    try {
      const hasLatLong = user.latitude && user.longitude;
      const latLong = hasLatLong ? user.latitude + '/' + user.longitude : '44.967243/103.771556';
      if(!hasLatLong) {
        await this.uiService.showToast('Cannot determine your location. Please check your location settings.')
      }     
      
      if (!last_update || last_update === '') last_update = DateTime.fromISO('1900-01-01T00:00:00.000Z').toISO() as string;
   
      const ret = await this.apiService.apiReturnsAny('get', 'stores/active/' + latLong + '/' + last_update)
      return (ret && Array.isArray(ret)) ? Store.buildMany(ret) : null
    } 
    catch (error) {    
      LoggerService.log(error + 'stores/active/')
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')
      return null
    }
  }  

  public async getMine (user: User, last_update: string) : Promise<Store[] | null> {      
    try {
      const hasLatLong = user.latitude && user.longitude;
      const latLong = hasLatLong ? user.latitude + '/' + user.longitude : '44.967243/103.771556';
      if(!hasLatLong) {
        await this.uiService.showToast('Cannot determine your location. Please check your location settings.')
      }     
      
      if (!last_update || last_update === '') last_update = DateTime.fromISO('1900-01-01T00:00:00.000Z').toISO() as string;

      const ret = await this.apiService.apiReturnsAny('get', 'stores/mine/' + latLong + '/' + last_update)
      return (ret && Array.isArray(ret)) ? Store.buildMany(ret) : null
    } 
    catch (error) {    
      LoggerService.log(error + 'stores/mine/')
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')
      return null
    }
  }  

}
